import { render, staticRenderFns } from "./AddAlternativeMatchDialog.vue?vue&type=template&id=d76a7aa6"
import script from "./AddAlternativeMatchDialog.vue?vue&type=script&lang=js"
export * from "./AddAlternativeMatchDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports